<template>
    <div id="contactComponent">
      <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
      <v-container>
        <v-layout class="mb-2" row wrap>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :label="$t('general.search')"
            clearable
            append-outer-icon="search">
          </v-text-field>
        </v-layout>
        <v-data-table
        :search="search"
        class="elevation-2"
        :headers="headers"
        :items="messages"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
        >
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                  {{header.text}}</h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr style="border-bottom: none;">
              <td class="text-sm-center">{{props.item.id}}</td>
              <td class="text-sm-center">{{props.item.name}}</td>
              <td class="text-sm-center">{{props.item.email}}</td>
              <td class="text-sm-center">{{props.item.phone_number}}</td>
              <td class="text-sm-center">{{props.item.subject}}</td>
              <td class="text-sm-center d-none" v-html="props.item.message"></td>
              <td class="text-sm-center">{{props.item.date_hour}}</td>
              <td class="text-sm-center text-justify">
                <v-btn color="error" outline icon small @click="remove(props.item)">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <td colspan="7"><span class="font-weight-black primary--text">{{$t('notifications.message')}}: </span><span v-html="props.item.message"></span></td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="removeDialog" max-width="500px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black error--text mb-0">{{ $t('general.deleteContact') }}</h2>
            </v-toolbar>
            <v-card-text class="text-sm-justify">
              <p>{{ $t('general.deleteElementQuestion') }}</p>
              <p class="font-weight-black"><span class="error--text">{{ $t('general.email') }}: </span>"{{removedItem.email}}"</p>
              <p class="font-weight-black"><span class="error--text">{{ $t('general.reason') }}: </span>"{{removedItem.subject}}"</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error darken-1"
                round
                flat
                @click="removeDialog = false">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="error"
                round
                depressed
                @click="deleteItem(removedItem)">
                {{ $t('general.delete') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
</template>
<script>
export default {
  name: 'contactComponent',
  data () {
    return {
      search: '',
      removeDialog: false,
      loading: false,
      pagination: {
        descending: true,
        sortBy: 'date_hour',
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      messages: [],
      removedItem: {
        email: '',
        subject: ''
      }
    }
  },
  computed: {
    heading () {
      return this.$t('general.contacts')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fa fa-envelope fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.email'),
          align: 'center',
          value: 'email',
          sortable: true
        },
        {
          text: this.$t('taxFields.phone'),
          align: 'center',
          value: 'phone_number',
          sortable: true
        },
        {
          text: this.$t('general.reason'),
          align: 'center',
          value: 'subject',
          sortable: true
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'date_hour',
          sortable: true
        },
        {
          text: '',
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.get()
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    remove (item) {
      this.removedItem = Object.assign({}, item)
      this.removeDialog = true
    },
    deleteItem (item) {
      this.loading = true
      this.$emit('deleteContact', { context: this, id: item.id })
    },
    get () {
      this.$emit('getContact', { context: this })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact.component.vue